import React from "react"
import * as styles from "./SpeechBabble.module.css"
import classNames from "classnames"

export type SpeechBabbleProps = {
  text: string
  x: number | string
  y: number | string
  type: "bottom-right" | "bottom-left" | "top-right" | "top-left"
}

const SpeechBabble = ({
  text = "",
  x = 0,
  y = 0,
  type = "bottom-right",
}: SpeechBabbleProps) => {
  return (
    <div
      className={classNames(styles.box, {
        [styles.bottomRight]: type === "bottom-right",
        [styles.bottomLeft]: type === "bottom-left",
        [styles.topRight]: type === "top-right",
        [styles.topLeft]: type === "top-left",
      })}
      style={{ left: x, bottom: y }}
    >
      <p className={styles.text}>{text}</p>
    </div>
  )
}

export default SpeechBabble
